export tag AA
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M16 3.89151L0 13.8915V20H4V16.1085L16 8.6085V20H20V0H16V3.89151Z">

export tag BB
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0H4V8H12V12H4V20H0V0Z">
				<path d="M20 20H8V16H16V4H8V0H20V20Z">

export tag CC
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 20V0H4.52753L20 20H14.9449L4 5.85916V20H0Z">

export tag DD
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M4 0H0V20H4V0Z">
				<path d="M8 20H20V0H8V4H16V16H8V20Z">
				<path d="M12 8H8V12H12V8Z">

export tag EE
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M15 0L0 20H20V16H8L11 12H20V8H14L20 0H15Z">
				<path d="M4 0H0V4H4V0Z">

export tag FF
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0H4V8H12V12H4V16H20V20H0V0Z">

export tag GG
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0V20H4V4H20V0H0Z">
				<path d="M8 8H20V20H16V12H8V8Z">

export tag HH
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0H20V4H0V0Z">
				<path d="M11.4821 16H20V20H0V16H6.85128L11.5179 8H16.1488L11.4821 16Z">

export tag II
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0L15 20H20L5 0H0Z">
				<path d="M4 16H0V20H4V16Z">

export tag JJ
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M4.92963 16L15.5963 0H20V20H16V6.60555L7.07037 20H0V16H4.92963Z">
				<path d="M4 0H0V4H4V0Z">

export tag KK
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M15.0704 4L4.40369 20H0V0H4V13.3945L12.9296 0H20V4H15.0704Z">
				<path d="M16 20H20V16H16V20Z">

export tag LL
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0H4V4H0V0Z">
				<path d="M0 16H4V20H0V16Z">
				<path d="M16 16H8V20H20V0H8V4H16V16Z">

export tag MM
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 20V0H12V8H8V4H4V20H0Z">
				<path d="M16 0H20V20H16V0Z">
				<path d="M12 12H8V20H12V12Z">

export tag NN
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 20V0H12V12H8V4H4V20H0Z">
				<path d="M16 0H20V20H8V16H16V0Z">

export tag OO
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M16.1085 16L6.1085 -6.07217e-07L0 -8.74228e-07L-1.74846e-07 4L3.8915 4L11.3915 16L-6.99382e-07 16L-8.74228e-07 20L20 20L20 16L16.1085 16Z">

export tag PP
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M20 0V12H16V4H6.40754L13.4075 12H8.09246L4 7.3229V20H0V0H20Z">

export tag QQ
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M6.1085 0L13.6085 12H8.8915L3.8915 4L0 4V0H6.1085Z">
				<path d="M0 16V20H20V16L0 16Z">

export tag RR
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M20 0V12H16V4H6.33862L20 20H14.7394L4 7.42082V20H0V0H20Z">

export tag SS
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M14.6629 20L0 3.05619L0.00012207 0H20.0001V12H16.0001V4H6.10657L19.9527 20H14.6629Z">
				<path d="M4 16H0V20H4V16Z">

export tag TT
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M12 0H8V16H0V20H20V16H12V0Z">
				<path d="M16 0H20V12H16V0Z">
				<path d="M4 0H0V12H4V0Z">

export tag UU
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M4 11.1716V0H0V12.8284L7.17157 20H20V0H16V16H8.82843L4 11.1716Z">

export tag VV
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M4.92963 4L15.5963 20H20V0H16V13.3945L7.07037 0H0V4H4.92963Z">
				<path d="M4 20H0V16H4V20Z">

export tag WW
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M4 14.1408L8.75298 8H13.811L4.52753 20H0V0H4V14.1408Z">
				<path d="M20 0H16V20H20V0Z">

export tag XX
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M15 6L12 10V0H7.5L0 10H5L8 6V16H12.5L20 6H15Z">

export tag YY
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M4 0H0V12H12V8H4V0Z">
				<path d="M20 0H16V16H0V20H20V0Z">

export tag ZZ
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M12 16L0 0H5L20 20H2.43527e-06V8H4V16H12Z">
				<path d="M20 0H16V4H20V0Z">

export tag N0
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0H20V4H0V0Z">
				<path d="M0 8H20V12H0V8Z">
				<path d="M20 16H0V20H20V16Z">

export tag N1
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 8H20V12H0V8Z">

export tag N2
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M12 0H0V4H12V0Z">
				<path d="M12 16H0V20H12V16Z">

export tag N3
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0H10V4H0V0Z">
				<path d="M20 8V12H0V8H20Z">
				<path d="M10 16H0V20H10V16Z">

export tag N4
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0H20V4H0V0Z">
				<path d="M0 8H10V12H0V8Z">
				<path d="M20 20V16H0V20H20Z">

export tag N5
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M0 0H20V4H0V0Z">
				<path d="M0 16H20V20H0V16Z">

export tag N6
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M20 0H0V4H20V0Z">
				<path d="M20 8H10V12H20V8Z">
				<path d="M0 20V16H20V20H0Z">

export tag N7
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M20 0H10V4H20V0Z">
				<path d="M0 8V12H20V8H0Z">
				<path d="M10 16H20V20H10V16Z">

export tag N8
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M10 0H0V4H10V0Z">
				<path d="M0 8V12H20V8H0Z">
				<path d="M0 16H20V20H0V16Z">

export tag N9
	def render
		<self>
			<svg viewBox="0 0 20 20">
				<path d="M10 20H20V16H10V20Z">
				<path d="M20 12V8H0V12H20Z">
				<path d="M20 4H0V0H20V4Z">